<template>
  <div class="my">
    <div class="top"></div>
    <div class="my-bg">
      <div
        class="bg"
        :style="{backgroundImage: `url(${userInfo.userBg})`}"
      >
        <van-uploader
          v-if="isLogin"
          class="uploader-box"
          :after-read="upload"
        ></van-uploader>
      </div>
    </div>
    <div class="my-content">
      <div class="my-boxing">
        <div
          class="my-box"
          v-if="isLogin"
        >
          <div class="my-img">
            <div class="img-border">
              <div class="img-box">
                <img
                  class="auto-img"
                  :src="userInfo.userImg"
                  alt=""
                >
              </div>
            </div>

            <div class="my-info">
              <div class="nickname">{{userInfo.nickName}}</div>
              <div class="desc">{{userInfo.desc == '' ? '这个家伙很懒，什么都没留下!' : userInfo.desc}}</div>
            </div>
          </div>
        </div>

        <div
          class="not-login"
          v-else
        >
          <span @click="goLogin">请先登录</span>
        </div>

        <div class="lists">
          <van-cell
            :title="item.title"
            is-link
            size="large"
            :icon="item.icon"
            :to="item.to"
            v-for="(item,index) in lists"
            :key="index"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import "../../assets/less/my.less";
import { utils } from "../../assets/js/Utils";
export default {
  data() {
    return {
      lists: [
        { title: "个人资料", to: { name: "Account" }, icon: "contact" },
        { title: "我的订单", to: { name: "Order" }, icon: "records" },
        { title: "我的收藏", to: { name: "Like" }, icon: "like-o" },
        { title: "收货地址", to: { name: "Address" }, icon: "free-postage" },
        { title: "安全中心", to: { name: "Security" }, icon: "setting-o" },
      ],
      isLogin: false,
      userInfo: {},
      // 1M
      maxSize: 1 * 1024 * 1024,
    };
  },

  created() {
    // 查询用户信息
    this.getUserInfo();
  },

  methods: {
    goLogin() {
      this.$router.push({ name: "Login" });
    },

    // 查询用户信息
    getUserInfo() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findMy",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "A001") {
            if (result.data.result.length > 0) {
              this.isLogin = true;
              this.userInfo = result.data.result[0];
            }
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 上传背景
    upload(file) {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      // 获取文件类型
      let type = file.file.type.split("/")[1];
      let imgTypes = ["png", "gif", "jpg", "jpeg"];
      // 验证文件类型
      // -1 就是找不到的时候
      if (imgTypes.indexOf(type) === -1) {
        this.$notify({
          message: "图片类型只支持" + imgTypes.join(","),
          color: "#fff",
          background: "#0c34ba",
        });
        return;
      }
      // 验证文件大小
      if (this.maxSize < file.file.size) {
        this.$notify({
          message: "上传文件大小不能超过" + this.maxSize / 1024 + "KB",
          color: "#fff",
          background: "#0c34ba",
        });
        return;
      }

      // 获取base64
      let base64 = file.content.replace(/data:image\/[A-Za-z]+;base64,/, "");

      // 参数序列化
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        imgType: type,
        serverBase64Img: base64,
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "POST",
        url: "/updateUserBg",
        data,
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == "I001") {
            this.userInfo.userBg = result.data.userBg;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>